import { Box, Toolbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
// import { useWindowSize } from 'usehooks-ts';

import i18n from 'config/i18n';
import { isSmallScreen } from 'utils';
import { HEADER_HEIGHT, RIGHT_BOTTOM_BORDER, SIDEBAR_WIDTH_MINIMIZED } from 'config';
import { resetAllState } from 'store/rootReducer';

import { useDispatch } from 'react-redux';
import * as Actions from '../../slice';

import { LayoutProps } from './types';
import { Header, Sidebar } from './containers';
import ScreenSizeWarning from './components/ScreenSizeWarning';

const Layout = ({ locale, isMenuOpen, children }: LayoutProps) => {
  const dispatch = useDispatch();

  const handleLanguage = (_: any, isAr: boolean) => {
    dispatch(Actions.setCurrentLocale(locale === 'en' ? 'ar' : 'en'));
    i18n.changeLanguage(locale === 'en' ? 'ar' : 'en');
    document.documentElement.lang = i18n.language;
    document.documentElement.style.direction = isAr ? 'rtl' : 'ltr';
  };

  const toggleDrawer = () => {
    dispatch(Actions.setMenuDrawerOpen(!isMenuOpen));
  };

  useEffect(() => {
    if (isSmallScreen()) {
      dispatch(Actions.setMenuDrawerOpen(false));
    }
  }, [window.screen.width]);

  const handleLogout = () => {
    dispatch(Actions.logout());
    resetAllState(dispatch);
  };

  const [showResolutionWarning, setWarning] = useState(
    window.screen.width < 1600 && !localStorage.getItem('optimized-monitor-warning')
  );
  return (
    <>
      {showResolutionWarning ? (
        <ScreenSizeWarning
          modalopen={showResolutionWarning}
          handleModalClose={() => {
            localStorage.setItem('optimized-monitor-warning', new Date().toISOString());
            setWarning(false);
          }}
        />
      ) : null}
      <Box
        className="root-container"
        sx={{
          display: 'flex',
          maxHeight: '100vh',
          height: '100%',
          minHeight: '100vh',
          background: `linear-gradient(315deg, #360A82 0%, #140430 100%)`
        }}
      >
        <Header
          handleLogout={handleLogout}
          isOpen={isMenuOpen}
          handleToggleDrawer={toggleDrawer}
          locale={locale}
          // title={title}
          // redirectPath={redirectPath}
          handleLanguage={handleLanguage}
          // topBarMenu={topBarMenu}
        />
        <Sidebar handleLogout={handleLogout} isOpen={isMenuOpen} handleToggleDrawer={toggleDrawer} />
        <Box
          component="main"
          className="main-content-wrapper"
          sx={{
            flexGrow: 1,
            overflow: 'auto',
            background: 'transparent',
            marginBottom: RIGHT_BOTTOM_BORDER + 'px',
            marginRight: RIGHT_BOTTOM_BORDER + 'px',
            borderBottomLeftRadius: '20px',
            borderBottomRightRadius: '20px'
          }}
          style={{ marginLeft: isSmallScreen() ? SIDEBAR_WIDTH_MINIMIZED : 0 }}
        >
          <Toolbar />
          <Box
            position="relative"
            className="content-container"
            sx={{
              height: 'calc(100vh - ' + (HEADER_HEIGHT + RIGHT_BOTTOM_BORDER) + 'px)',
              borderTopRightRadius: '20px',
              borderTopLeftRadius: '20px',
              background: 'linear-gradient(142deg, #E4F2FB 0%, #EFE6FB 100%)',
              overflow: 'hidden'
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Layout;
